"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGlobalVariables = void 0;
var _getGridVariables = require("../layout/grid/getGridVariables");
const getGlobalVariables = theme => {
  const grids = (0, _getGridVariables.getGridVariables)(theme.mediaQueries);
  return {
    ':root': {
      [grids.variable]: grids.value
    },
    ...grids.mediaQueries
    // Use "theme.utils.mergeStyles" in a case if we have any other variables changing in media queries
  };
};
exports.getGlobalVariables = getGlobalVariables;